import { Popover } from '@byecode/ui'
import { getImageFullUrlInCommon, spaceGradeCodeMap, spaceVersionEnum, useAtomAction } from '@lighthouse/shared'
import { findIndex } from 'rambda'
import React, { useCallback, useMemo, useState } from 'react'
import { useImmer } from 'use-immer'

import { setWorkSpaceIdAtom } from '@/atoms/workSpace/action'
import { workSpaceListAtom } from '@/atoms/workSpace/state'
// import { useAsyncAction, useBoundStore } from '@/stores'
import { useWorkSpace, useWorkSpaceList } from '@/hooks/useWorkSpace'

import { SpaceCreatorModal } from '../components/SpaceCreatorModal'
import { SpaceMenu } from '../components/SpaceMenu'
import { SpaceAvatar } from '../SpaceAvatar'

interface SpaceConfigureState {
    isSpaceSettingOpen: boolean
    isCreateSpace: boolean
}

export const SpaceConfigure: React.FC = () => {
    const workspace = useWorkSpace()
    const [open, setOpen] = useState(false)
    const { id, name, icon, members, version } = workspace
    const workSpaceList = useWorkSpaceList()
    const { run: setWorkSpaceListAtom } = useAtomAction(workSpaceListAtom)
    const { run: setWorkSpaceId } = useAtomAction(setWorkSpaceIdAtom)
    const [state, setState] = useImmer<SpaceConfigureState>({
        isSpaceSettingOpen: false,
        isCreateSpace: false
    })

    const browseStart = useMemo(() => {
        return workSpaceList.some(space => space.browseStart)
    }, [workSpaceList])

    // 跳转空间
    const handleChangeSpace = useCallback(
        (spaceId: string) => {
            if (id === spaceId) {
                return
            }
            setOpen(false)
            setWorkSpaceId(spaceId)
            setWorkSpaceListAtom(draft => {
                const index = findIndex(item => item.id === spaceId, draft)
                draft[index].browseStart = false
            })
        },
        [id, setWorkSpaceId, setWorkSpaceListAtom]
    )

    const handleCreateSpace = useCallback(
        (isOpen: boolean) => {
            setOpen(false)
            setState(draft => {
                draft.isCreateSpace = isOpen
            })
        },
        [setState]
    )

    return (
        <>
            <Popover width="target" opened={open} withinPortal zIndex={200} onChange={setOpen}>
                <Popover.Target>
                    <SpaceAvatar
                        radius="5px"
                        name={name}
                        icon={getImageFullUrlInCommon(icon)}
                        dot={browseStart}
                        active={open}
                        members={members}
                        versionCode={version ? spaceGradeCodeMap[version] : spaceVersionEnum.FREE}
                    />
                </Popover.Target>
                <Popover.Dropdown>
                    <SpaceMenu
                        space={workspace}
                        workspaces={workSpaceList}
                        onChangeSpace={handleChangeSpace}
                        // onSpaceSet={handleSpaceSet}
                        onCreateSpace={handleCreateSpace}
                    />
                </Popover.Dropdown>
            </Popover>

            <SpaceCreatorModal
                title="创建空间"
                open={state.isCreateSpace}
                onClose={() => {
                    handleCreateSpace(false)
                }}
            />
        </>
    )
}
